import { useCopilotMeta } from '@customerio/hydra-copilot/react';
import { Badge, Tooltip } from '@customerio/pluma-components/react';

import { useCopilotSessionContext } from './session-provider';
import { shouldShowAgentBetaLabel } from '../utils/agent-beta-label-visibility';

const AGENT_BETA_TOOLTIP =
  'Agent is in beta while we refine the experience. Your feedback helps us make it more useful for your team.';

/**
 * Purple Beta label with tooltip; renders nothing when the session is named.
 */
export function AgentBetaLabel() {
  const session = useCopilotSessionContext();
  const meta = useCopilotMeta(session);
  const isVisible = shouldShowAgentBetaLabel(meta.name);

  if (!isVisible) {
    return null;
  }
  return (
    <Tooltip content={AGENT_BETA_TOOLTIP} placement="top" isCustom={true}>
      {(context) => (
        <Badge color="purple" ref={context.reference.setReference} {...context.reference.getReferenceProps()}>
          Beta
        </Badge>
      )}
    </Tooltip>
  );
}
